export default __webpack_public_path__ + "payments.5a99a92a.png";